import React from "react";
import CriticalityTable from "../components/dashboard_components/criticality_table";
import { Ibox } from "../components/common/ibox";

export default function HighCriticality(props) {
    return (<CriticalityTable {...props} />);
}